import { useSubscription } from '@apollo/client'

export function useSubscriptionForRefetch(subscription, refetch) {
  useSubscription(subscription, {
    onSubscriptionData: () => refetch()
  })
}
